<template>
    <div class="home-reseller-admin mb-3 mt-4">

        <h1 class="mb-4">{{ $i18n.gt('HEADING_RESELLER_ADMIN_DASHBOARD') }}</h1>

        <div class="row mb-4">
            <div class="col-sm-4">
                <div class="frame card">
                    <h3 class="card-header">{{ $i18n.gt('HEADING_COMPANIES_PLANS') }}</h3>
                    <div class="card-body">
                        <ul>
                            <li>
                                <router-link :to="`/company/resellerAdmin/${resellerId}`">{{
                                        $i18n.gt('LABEL_MANAGE_COMPANIES_PLANS')
                                    }}
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="frame card">
                    <h3 class="card-header">{{ $i18n.gt('HEADING_PARTICIPANTS') }}</h3>
                    <div class="card-body">
                        <ul>
                            <li>
                                <router-link :to="`/participant/resellerAdmin/${resellerId}`">{{
                                        $i18n.gt('HEADING_MANAGE_PARTICIPANTS')
                                    }}
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="frame card">
                    <h3 class="card-header">{{ $i18n.gt('HEADING_ADMIN_FUNCTIONS') }}</h3>
                    <div class="card-body">
                        <ul>
                            <li>
                                <router-link :to="`/companyAdmin/resellerAdmin/${resellerId}`">{{ $i18n.gt('LABEL_MANAGE_ADMINS') }}</router-link>
                            </li>
<!--                            <li>-->
<!--                                <router-link to="/clientReports">{{ $i18n.gt('LABEL_CLIENT_REPORTS') }}</router-link>-->
<!--                            </li>-->
                        </ul>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>

import Vue from 'vue'

/**
 * Home page for global admins
 */
export default Vue.extend({
  name: "HomeResellerAdmin",
  props: {
    resellerId: Number
  }
})
</script>

<style lang="scss">

@media (max-width: 500px) {
  .home-admin {
    .btn {
      width: 100%;
    }
  }
}

@media (max-width: 1000px) {
  .home-admin {
    .btn {
      margin-bottom: 1em;
    }
  }
}

</style>
